export interface EventWizardDateTimeProps {
  // add props here
}

export enum DateTimeErrorType {
  END_DATE_GREATER = 0,
  END_TIME_GREATER = 1,
  EVENT_PASSED_TIME = 3,
  EVENT_PASSED_DATE = 4,
  EVENT_TOO_LONG_DAYS = 5,
}

const MAX_EVENT_LENGTH_MONTHS = 6;
export const MAX_EVENT_LENGTH_DAYS = MAX_EVENT_LENGTH_MONTHS * 30;

export const startTimeInputDropdownID = 'startTimeInputDropdownID';
export const endTimeInputDropdownID = 'endTimeInputDropdownID';
